export enum CustomerAssortmentFilter {
  None = 'None',
  DeliveryAcceptanceStatus = 'DeliveryAcceptanceStatus',
}